<template>
  <div class="container">
    <generic-table
      ref="datatable"
      :title="$t('backups')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/core/backup/datatables"
    />
    <backup-modal ref="backup_modal" @success="refresh" />
  </div>
</template>

<script>
import BackupModal from "./backup_modal/Index.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  confirm_deletion_dialog,
  del,
  error_message,
  translate_file_size,
  generate_datatables_buttons,
  format_date_time,
  download,
  success_message,
} from "@/utils";

export default {
  name: "BackupsDatatables",
  components: { GenericTable, BackupModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("create"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("backup"),
          searchable: false,
          width: "85%",
          data: (row) => {
            let r = `<div class="columns">
                      <div class="column is-9">
                        <div class="title is-5 mb-0">${
                          row.name
                        } (${translate_file_size(row.settings.size)})</div>
                        <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-calendar"></i></span> ${format_date_time(
                          row.create_date
                        )}</div>
                        <div class="subtitle is-6"><span class="icon"><i class="fa fa-map-marker"></i></span> ${
                          row.path
                        }</div>
                      </div>
                      <div class="column is-3">`;
            if (row.include_frontend)
              r += `<div class="tags has-addons">
                      <span class="tag"><span class="icon has-text-primary"><i class="fa fa-check"></i></span></span>
                      <span class="tag is-primary">${v.$t("frontend")}</span>
                    </div>`;
            else
              r += `<div class="tags has-addons">
                      <span class="tag"><span class="icon has-text-danger"><i class="fa fa-times"></i></span></span>
                      <span class="tag is-danger">${v.$t("frontend")}</span>
                    </div>`;

            if (row.include_backend)
              r += `<div class="tags has-addons">
                      <span class="tag"><span class="icon has-text-primary"><i class="fa fa-check"></i></span></span>
                      <span class="tag is-primary">${v.$t("backend")}</span>
                    </div>`;
            else
              r += `<div class="tags has-addons">
                      <span class="tag"><span class="icon has-text-danger"><i class="fa fa-times"></i></span></span>
                      <span class="tag is-danger">${v.$t("backend")}</span>
                    </div>`;
            r += `</div>
                    </div>`;
            return r;
          },
        },
        // {
        //   title: v.$t("date"),
        //   width: "15%",
        //   name: "create_date",
        //   data: (row) => {
        //     return format_date_time(row.create_date) || "";
        //   },
        // },

        {
          title: v.$t("options"),
          searchable: false,
          width: "15%",
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete backup?"),
                    v,
                    () => {
                      del("/core/backup", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("download"),
                icon: "fa fa-download",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  v.$root.loader(true);
                  download(
                    `/core/backup/download?uuid=${uuid}`,
                    `${row.name}.zip`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      console.error(error);
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.backup_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
};
</script>

<style></style>
